module.exports = __webpack_public_path__ + "img/caldwellhall-v-474x632.be4b5d7f.jpg";